import React, { Component } from "react";
import { connect } from "react-redux";
import { func, number, object } from "prop-types";

import RoundIcon from "../RoundIcon";
import Icon from "../Icon";
import PageContent from "../PageContent";
import { retry } from "../../logic/actions/livenessTest";
import { go } from "../../logic/actions/navigation";
import { logEvent, LIVENESS_TEST_RETRY } from "../../logic/eventLogger";
import { THANK_YOU } from "../../logic/enums/pages";

export class PageLivenessTestRetry extends Component {
  static propTypes = {
    retry: func,
    retriesLeft: number,
    livenessTestData: object,
  };

  constructor(props) {
    super(props);
    this.retry.bind(this);
  }

  componentDidMount() {
    if (this.props.retriesLeft === 0) {
      this.props.go(THANK_YOU);
    }
  }

  retry = () => {
    const value =
      this.props.livenessTestData && this.props.livenessTestData.items[0].type;
    logEvent(LIVENESS_TEST_RETRY, { value });
    logEvent(
      LIVENESS_TEST_RETRY +
        "_" +
        (typeof value === "string" && value.toLowerCase)
    );
    this.props.retry();
  };

  render() {
    const buttonClass = `btn ${this.props.retriesLeft ? "green" : "gray"}`;
    let errMessage;
    if (this.props.livenessTestData.items[0].type !== "SVR3DFL") {
      errMessage =
        "We were unable to process extra checks, you can retry or contact our support";
    } else {
      errMessage =
        this.props.errorMessage ||
        "We were unable to process extra checks, you can retry or contact our support";
    }

    return (
      <PageContent>
        <header />
        <h1>Issue</h1>
        <div className="panel bg-blue flex-row">
          <RoundIcon color="blue">
            <Icon name="Info" color="white" />
          </RoundIcon>
          <div className="panel-content">
            {this.props.retriesLeft ? (
              <p>{errMessage}</p>
            ) : (
              <p>
                We were unable to process extra checks, please contact our
                support
              </p>
            )}
          </div>
        </div>
        <div>
          <button
            disabled={!this.props.retriesLeft}
            onClick={this.retry}
            className={buttonClass}
          >
            RETRY ({this.props.retriesLeft || 0} attempts left)
          </button>
        </div>
      </PageContent>
    );
  }
}

export default connect((state) => state.livenessTest, { retry, go })(
  PageLivenessTestRetry
);
